import { StrictMode } from "react";
import "./index.css";
import App from "./App.tsx";
import "@mantine/core/styles.css";
import '@mantine/tiptap/styles.css';
import '@mantine/notifications/styles.css';
import { theme } from "@/theme";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";

export default function ActivationApp() {
  return (
    <StrictMode>
      <MantineProvider theme={theme} defaultColorScheme="auto">
        <Notifications zIndex={5000} />
        <App />
      </MantineProvider>
    </StrictMode>
  )
}
